import { SxProps, Theme } from '@mui/material';

export const titleSX: SxProps<Theme> = (theme) => ({
	textAlign: 'center',
	font: 'normal normal 800 40px/40px Open Sans',
	letterSpacing: '0px',
	color: '#2C2C2C',
	textTransform: 'uppercase',
	[theme.breakpoints.down('md')]: {
		textAlign: 'center',
	},
	[theme.breakpoints.down('sm')]: {
		textAlign: 'center',
		fontSize: 'var(--font-size-xl)',
	},
});

export const subtitleSX: SxProps<Theme> = (theme) => ({
	mt: '14px',
	px: '15%',
	font: 'normal normal normal 15px/25px Open Sans',
	color: '#2C2C2C',
	letterSpacing: '0px',
	textAlign: 'center',
	[theme.breakpoints.down('md')]: {
		px: '0px',
	},
});
